export enum ApplicationName {
    Default = 'Ekomplet',
    Ekomplet = 'Ekomplet',
    Sema = 'Sema',
}